export default "__VITE_ASSET__BPXcGEa5__"